module.exports = __webpack_public_path__ + "media/images/about/h_2-50337d0daf36dd713439178e090eedab.png";